import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AttachJsonPage from './pages/AttachJsonPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AttachJsonPage/>} />
      </Routes>
    </Router>
  );
};

export default App;